
  export default {
  layout: 'error-page',
   head() {
      return {
        title: this.title + " | Goa App",
        meta: [{
            hid: 'og:title',
            property: 'og:title',
            content: this.title + " | Goa App"
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.title + " | Goa App"
          }
        ],
      }
    },
    data() {
      return {
        title:"Sign Up",
        form: {
          username: null,
          phoneNumber : null,
          password : null,
          email:null,
          password: null,
          cpassword: null,
          slug:null
        },
         //Form error variables
       errors: {
          formError: null,
          formErrMsg: "Opps! Something went wrong, please try again."
        },
        // Form submit variables
        submit: {
          loading: false,
          success: false,
          errored: false
        }
      }
    },
      // Check login token
    mounted() {
      if (!localStorage.getItem("authToken")) {
        this.$router.push({
          path: '/register/'
        })
      } else {
        this.$router.back()
      }
    },

  methods:{

    string_to_slug(str, phoneNumber) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
        var to = "aaaaaeeeeiiiioooouuuunc------";

        for (var i = 0, l = from.length; i < l; i++) {
          str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
          .replace(/\s+/g, '-') // collapse whitespace and replace by -
          .replace(/-+/g, '-'); // collapse dashes

          var number = phoneNumber.replace(/\D/g, '').slice(-10);

        return str + '-' + number ;
      },

    // To clear the submit error message
    clearFormErrMsg(){
      this.errors.formError = null;
      this.submit.success = false
      this.submit.errored = false
    },
    // Validate and Submit form data to LOGIN
    sendMessage() {
      // Clear all submit errors before API call
      this.errors.formError = null;
      this.submit.success = false
      this.submit.errored = false
      // Validate all fields for making the API call, throw error and not call API if validation errors are present
      this.$refs.registrationForm.validate().then((success) => {
        if (!success) {
          // run your error code here
          this.errors.formError = "One or more incorrect fields present, please fix.";
        }
        else {
          // If Valid form
          // Create url encoded formData instance to pass the data to the API
          var formData = new URLSearchParams();
           formData.append("username", this.form.username.trim());
              formData.append("slug", this.string_to_slug(this.form.username.trim().toLowerCase(), this.form.phoneNumber.trim()));
          formData.append("phone", this.form.phoneNumber.trim());
          formData.append("password", this.form.password.trim());
              formData.append("email", this.form.email.trim());
              formData.append("isAdmin", false);
          // Add header for the API
          const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
          }
          this.submit.loading = true;
          // AXIOS api call to add SIGNIN api
          this.$axios
          .post("/api/users", formData, {headers: headers})
          .then(response => {
            this.submit.success = true
            this.submit.errored = false
            let value = this.getCryptKey(response.data);
            localStorage.setItem("authToken", "bearer " + value.token);
            this.$store.commit('login', value.token);
            this.myProfile(value.token);
          })
          .catch(error => {
            if(error.response)
            this.errors.formErrMsg = this.getCryptKey(error.response.data)
            this.submit.success = false
            this.submit.errored = true
          })
          .finally(() => {
            this.submit.loading = false
          });
        }
      });
    },
    myProfile(token) {
        // Add header for the API
        const headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': "bearer " + token,
        }
        // AXIOS api call to add SIGNIN api
        this.$axios
          .get("/api/users/me/", {
            headers: headers
          })
          .then(response => {
            // New flow
            let value = this.getCryptKey(response.data);
            localStorage.setItem("profile", JSON.stringify(value));
            this.$store.commit('profile', value.username);
            this.$router.back()
          })
          .catch(error => {});
      },
  }
}

